import React, { createContext, useContext, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";

import { GET_ALL_TENANT_USERS } from "../queries/users";
import { buildUserNamesById } from "../utils/users";

const UsersContext = createContext(undefined);

export const UsersProvider = ({ children }) => {
  const { clientId } = useSelector((s) => s.auth || {});

  const { data, loading, error } = useQuery(GET_ALL_TENANT_USERS, {
    variables: {
      clientId,
    },
    skip: !clientId,
    fetchPolicy: "cache-and-network",
  });

  const value = useMemo(() => {
    const allTenantUsers = data?.users ?? [];

    return {
      tenantUsers: {
        users: allTenantUsers,
      },
      tenantUserNamesById: buildUserNamesById(allTenantUsers),
      loading,
      error,
    };
  }, [data, loading, error]);

  return (
    <UsersContext.Provider value={value}>{children}</UsersContext.Provider>
  );
};

export const useTenantUsers = () => {
  const context = useContext(UsersContext);
  if (context === undefined) {
    throw new Error("useTenantUsers must be used within a UsersProvider");
  }
  return context;
};
